import actions from "./actions";

const initState = {
    tagGroups: null,
    tagGroup: null,
    createTagGroupState: null,
    createTagGroupResult: null,
    readTagGroupsState: null,
    readTagGroupState: null,
    updateTagGroupState: null,
    deleteTagGroupState: null,
    activateTagGroupState: null,
    tags: null,
    tag: null,
    createTagState: null,
    createTagResult: null,
    readTagsState: null,
    readTagState: null,
    updateTagState: null,
    deleteTagState: null,
    activateTagState: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.CREATE_TAG_GROUP_REQUEST:
            return {
                ...state,
                createTagGroupState: 'request',
            };
        case actions.CREATE_TAG_GROUP_SUCCESS:
            return {
                ...state,
                createTagGroupState: 'success',
                createTagGroupResult: action.data,
            };
        case actions.READ_TAG_GROUPS_REQUEST:
            return {
                ...state,
                readTagGroupsState: 'request',
            };
        case actions.READ_TAG_GROUPS_SUCCESS:
            return {
                ...state,
                readTagGroupsState: 'success',
                tagGroups: action.tagGroups,
            };
        case actions.READ_TAG_GROUP_REQUEST:
            return {
                ...state,
                readTagGroupState: 'request',
            };
        case actions.READ_TAG_GROUP_SUCCESS:
            return {
                ...state,
                readTagGroupState: 'success',
                tagGroup: action.tagGroup,
            };
        case actions.UPDATE_TAG_GROUP_REQUEST:
            return {
                ...state,
                updateTagGroupState: 'request',
            };
        case actions.UPDATE_TAG_GROUP_SUCCESS:
            return {
                ...state,
                updateTagGroupState: 'success',
            };
        case actions.DELETE_TAG_GROUP_REQUEST:
            return {
                ...state,
                deleteTagGroupState: 'request',
            };
        case actions.DELETE_TAG_GROUP_SUCCESS:
            return {
                ...state,
                deleteTagGroupState: 'success',
            };
        case actions.ACTIVATE_TAG_GROUP_REQUEST:
            return {
                ...state,
                activateTagGroupState: 'request',
            };
        case actions.ACTIVATE_TAG_GROUP_SUCCESS:
            return {
                ...state,
                activateTagGroupState: 'success',
            };
        case actions.CREATE_TAG_REQUEST:
            return {
                ...state,
                createTagState: 'request',
            };
        case actions.CREATE_TAG_SUCCESS:
            return {
                ...state,
                createTagState: 'success',
                createTagResult: action.data,
            };
        case actions.READ_TAG_REQUEST:
            return {
                ...state,
                readTagState: 'request',
            };
        case actions.READ_TAG_SUCCESS:
            return {
                ...state,
                readTagState: 'success',
                tag: action.tag,
            };
        case actions.UPDATE_TAG_REQUEST:
            return {
                ...state,
                updateTagState: 'request',
            };
        case actions.UPDATE_TAG_SUCCESS:
            return {
                ...state,
                updateTagState: 'success',
            };
        case actions.DELETE_TAG_REQUEST:
            return {
                ...state,
                deleteTagState: 'request',
            };
        case actions.DELETE_TAG_SUCCESS:
            return {
                ...state,
                deleteTagState: 'success',
            };
        case actions.ACTIVATE_TAG_REQUEST:
            return {
                ...state,
                activateTagState: 'request',
            };
        case actions.ACTIVATE_TAG_SUCCESS:
            return {
                ...state,
                activateTagState: 'success',
            };
        case actions.TAG_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
